// Polyfill for process.env compatibility with Vite
// This ensures CRA-style process.env.PUBLIC_URL works

if (typeof window !== "undefined" && !window.process) {
  window.process = {
    env: {
      NODE_ENV:
        import.meta.env.MODE === "production" ? "production" : "development",
      PUBLIC_URL: "", // In Vite, use absolute paths starting with /
      REACT_APP_API_URL: import.meta.env.VITE_API_URL || "",
      REACT_APP_BASE_URL: import.meta.env.VITE_BASE_URL || "",
    },
  };
}

// Also set it on global process if it exists
if (typeof process !== "undefined" && !process.env.PUBLIC_URL) {
  process.env.PUBLIC_URL = "";
}
